import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import SchedulerTable from './components/SchedulerTable'
import {useParams} from 'react-router-dom'
import SchedulerTableFilter from './components/SchedulerTableFilter'
import {useAppSelector} from '../../../setup/redux/hooks'
import {selectUser} from '../../modules/auth/redux/AuthRedux'
import {PlanType} from '../pricing/pricing.constant'

const SCHEDULER_PLAN_LIMITS: Record<string, number> = {
  [PlanType.SUBSCRIPTION_BASIC]: 1,
  [PlanType.SUBSCRIPTION_STANDARD]: 1,
  [PlanType.SUBSCRIPTION_PREMIUM]: 5,
}

type Props = {
  className: string
}
const SchedulerPage: FC<Props> = (props) => {
  const intl = useIntl()
  const {id} = useParams<{id: string}>()
  const user = useAppSelector(selectUser)
  const planLimit = user?.planType ? SCHEDULER_PLAN_LIMITS[user.planType] ?? 0 : 0

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'SCHEDULER.PAGE_TITLE'})}</PageTitle>

      {/* Plan Info Notice */}
      <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed p-5 mb-5'>
        <i className='fas fa-info-circle text-primary fs-3 me-3 mt-0'></i>
        <div className='fs-7 text-gray-700'>
          <span>
            {intl.formatMessage({id: 'Scheduler.PLAN_LIMITS.FEATURE_DESC'})}
          </span>
          {' '}
          <span>
            {intl.formatMessage(
              {id: 'Scheduler.PLAN_LIMITS.PLAN_NOTE'},
              {limit: planLimit, maxLimit: 5}
            )}
          </span>
          {' '}
          <span>
            {intl.formatMessage({id: 'Scheduler.PLAN_LIMITS.FOLDER_UNIQUE_SHORT'})}
          </span>
        </div>
      </div>

      <div className='card mb-10'>
        <SchedulerTableFilter />
        <div className='card-body p-10'>
          <SchedulerTable userId={id} />
        </div>
      </div>
    </>
  )
}

export default SchedulerPage
